import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { ServiceBase } from './service-base.model';
import { catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { JwtHelperService } from '@auth0/angular-jwt';
import { AddUserModel } from '../request/AddUserForDto.model';
import { UseUserIndexModel } from '../request/UseUserIndexForDto.model';
import { UpdateUserRoleModel } from '../request/UpdateUserRoleForDto.model';
import { LoginModel } from '../request/LoginForDto.model';
import { UseDealerCodeModel } from '../request/UseDealerCodeForDto.model';

@Injectable()
export class AuthUserService extends ServiceBase {

  baseUrl = environment.apiUrl + 'Auth/';
  userToken: any;
  decodedToken: any;
  jwtHelper: JwtHelperService = new JwtHelperService();

  constructor(private http: HttpClient) {
    super();
  }

  // 1.1.1 取得使用者清單 
  getUserListService() {
    return this.http.get(this.baseUrl + 'data', { headers: this.requestHeaders() })
    .pipe(catchError((err) => { return throwError(() => err); })); // );
  }

  // 1.1.2 新增一位使用者
  addUserService(model: AddUserModel) {
    return this.http.post(this.baseUrl + 'add', model, { headers: this.requestHeaders() })
    .pipe(catchError((err) => { return throwError(() => err); })); // );
  }

  // 1.1.3 修改使用者資料
  updateUserService(model: AddUserModel) {
    return this.http.post(this.baseUrl + 'edit', model, { headers: this.requestHeaders() })
    .pipe(catchError((err) => { return throwError(() => err); })); // );
  }

  // 1.1.4 刪除一位使用者
  deleteUserService(model: UseUserIndexModel) {
    return this.http.delete(this.baseUrl + 'delete' + '/' + model.UserIndex, { headers: this.requestHeaders() })
    .pipe(catchError((err) => { return throwError(() => err); })); // );
  }

  // 1.1.5 取得使用者所擁有的角色
  getUserRoleService(model: UseUserIndexModel) {
    return this.http.get(this.baseUrl + 'get/role' + '/' + model.UserIndex, { headers: this.requestHeaders() })
    .pipe(catchError((err) => { return throwError(() => err); })); // );
  }

  // 1.1.6 調整使用者對應的角色
  updateUserRoleService(model: UpdateUserRoleModel[]) {
    return this.http.post(this.baseUrl + 'edit/userrole', model, { headers: this.requestHeaders() })
    .pipe(catchError((err) => { return throwError(() => err); })); // );
  }

  // 1.1.7 使用者登入
  loginService(model: LoginModel) {
    console.log('baseUrl', this.baseUrl);
    return this.http.post(this.baseUrl + 'login', model, { headers: this.requestHeaders() })
    .pipe(catchError((err) => { return throwError(() => err); })); // );
  }


  
  // 1.1.10 取得經銷商所屬人員
  getDealerUserService(model: UseDealerCodeModel) {
    return this.http.post(this.baseUrl + 'dealer', model, { headers: this.requestHeaders() })
      .pipe(catchError((err) => { return throwError(() => err); }));
  }

  getCaptcha(){
    var nDate = new Date();
    var vDate = nDate.getFullYear() +"/"+ (nDate.getMonth()+1) +"/"+ nDate.getDate() + " " + nDate.getHours() + ":" + nDate.getMinutes() + ":" + nDate.getSeconds();
    console.log('vDate', vDate);
    return this.http.get<any>(this.baseUrl + 'user/captcha', { headers: this.requestHeaders() })
      .pipe(catchError((err) => { return throwError(() => err); })); // .catch(this.handleError);
  }

  setSession(authResult: any) {
    this.userToken = authResult.Token;
    localStorage.setItem('Token', authResult.Token);
    // localStorage.setItem('RefreshToken', authResult.RefreshToken);
    this.decodedToken = this.jwtHelper.decodeToken(this.userToken);
  }

  setAuth(authList: any) {
    localStorage.setItem('Auth', authList);
  }

  getToken() {
    return localStorage.getItem('Token');
  }

  getDecodedToken() {
    const Token = this.getToken();
    // console.log('token', Token);
    return this.jwtHelper.decodeToken((Token == null ? undefined : Token));
  }

}
